import { selectCanMoveCargoToUndispatched } from "../../../ducks/data/route-with-stops/selectors";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../redux-store";
import { LoadingButton } from "@mui/lab";
import { moveUndispatchedCargoToRoute } from "../../../ducks/data/undispatched-cargos";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Dialog from "@mui/material/Dialog";
import { Button } from "@mui/material";

const MoveToUndispatched = ({ cargoId }: { cargoId: string }) => {
  const { t } = useTranslation(["translation", "undispatchedCargos"]);
  const [shouldShowConfirmPrompt, setShouldShowConfirmPrompt] = useState(false);
  const [requestInProgress, setRequestInProgress] = useState(false);
  const dispatch = useAppDispatch();

  const canMoveCargoToUndispatched = useSelector(
    selectCanMoveCargoToUndispatched(cargoId)
  );

  if (!canMoveCargoToUndispatched) {
    return null;
  }

  const onConfirmMoveToUndispatchedClick = async () => {
    setRequestInProgress(true);
    try {
      await dispatch(
        moveUndispatchedCargoToRoute({ cargoId, routeId: null })
      ).unwrap();
    } catch (err) {
      // TODO: check for activities error
      console.error("Error moving cargo to undispatched", err);
    } finally {
      setRequestInProgress(false);
    }
  };

  return (
    <>
      <Dialog
        onClose={() => setShouldShowConfirmPrompt(false)}
        open={shouldShowConfirmPrompt}
      >
        <div className="px-6 py-4">
          <div className="text-lg">
            {t("undispatchedCargos:confirmMoveToUndispatched")}
          </div>
          <div className="flex gap-2 justify-between w-100 mt-4">
            <Button
              variant="outlined"
              size="large"
              fullWidth
              disabled={requestInProgress}
              onClick={() => setShouldShowConfirmPrompt(false)}
            >
              {t("translation:Back")}
            </Button>
            <LoadingButton
              variant="contained"
              size="large"
              fullWidth
              loading={requestInProgress}
              onClick={onConfirmMoveToUndispatchedClick}
            >
              {t("undispatchedCargos:continue")}
            </LoadingButton>
          </div>
        </div>
      </Dialog>
      <Button
        variant="contained"
        size="large"
        fullWidth
        onClick={() => setShouldShowConfirmPrompt(true)}
      >
        {t("undispatchedCargos:moveToUndispatched")}
      </Button>
    </>
  );
};

export default MoveToUndispatched;
